// extracted by mini-css-extract-plugin
export default {"root":"CloseableDialog-module__root___34Pw4","icon":"CloseableDialog-module__icon___Sej4i"};